export const FetchState = {
  NotLoading: 'NotLoading',
  Pending: 'Pending',
  Fulfilled: 'Fulfilled',
  Rejected: 'Rejected',
};
